import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import * as Sentry from "@sentry/react";

// ✅ Capacitor deep link / Universal Link support
import { App as CapApp } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";

Sentry.init({
  dsn: "PASTE_DSN_HERE",

  environment: import.meta.env.MODE || "development",

  release: "watchparty-client@1.0.0",

  tracesSampleRate: 0.05,
});

// ✅ Helper: navigate React Router (BrowserRouter) without full reload
function navigateSpa(pathnameWithSearch) {
  try {
    window.history.pushState({}, "", pathnameWithSearch);
    window.dispatchEvent(new PopStateEvent("popstate"));
  } catch {
    // fallback: hard nav if needed
    try {
      window.location.href = pathnameWithSearch;
    } catch {
      // ignore
    }
  }
}

function setupCapacitorUniversalLinks() {
  try {
    // Only run inside native (iOS/Android)
    if (!Capacitor?.isNativePlatform?.()) return;

    CapApp.addListener("appUrlOpen", (event) => {
      try {
        const raw = event?.url || "";
        if (!raw) return;

        const u = new URL(raw);

        // Only accept your domains (safety)
        const host = (u.hostname || "").toLowerCase();
        const allowedHosts = new Set(["watchpartyrooms.com", "www.watchpartyrooms.com"]);
        if (!allowedHosts.has(host)) return;

        // Route only the paths you care about
        const path = `${u.pathname || "/"}${u.search || ""}`;

        // Example: /room/abc123?token=...
        if (path.startsWith("/room/")) {
          navigateSpa(path);
        } else if (path === "/" || path.startsWith("/terms") || path.startsWith("/privacy")) {
          navigateSpa(path);
        }
      } catch {
        // ignore
      }
    });
  } catch {
    // ignore
  }
}

// ✅ Run once at startup
setupCapacitorUniversalLinks();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);